module.exports = __webpack_public_path__ + "img/layout_top_tree_left_right.53d82cc8.svg";